<template>
  <div class="applied-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="100px" inline>
        <el-form-item label="规格型号">
          <el-select v-model="queryParams.productModel" size="small" clearable placeholder="请选择规格型号">
            <el-option
                v-for="subItem in modelOptions"
                :key="subItem.value"
                :label="subItem.name"
                :value="subItem.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" size="small" clearable placeholder="请选择状态">
            <el-option
                v-for="subItem in enumStatus"
                :key="subItem.value"
                :label="subItem.name"
                :value="subItem.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" round icon="el-icon-search" @click="getPageList()">搜索</el-button>
          <el-button round size="small" @click="onClickClear">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="selection"
              align="center"
              width="45">
          </el-table-column>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="productName"
              show-overflow-tooltip
              align="center"
              label="产品名称"
              width="120">
          </el-table-column>
          <el-table-column
              prop="productCount"
              show-overflow-tooltip
              align="center"
              label="申请数量"
              width="100">
          </el-table-column>
          <el-table-column
              prop="productModel"
              show-overflow-tooltip
              align="center"
              label="规格型号"
              width="120">
            <template slot-scope="scope">
              {{ eachModel(scope.row.productModel) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="lotNumber"
              show-overflow-tooltip
              align="center"
              label="批号"
              width="120">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="申请时间"
              width="200">
          </el-table-column>
          <el-table-column
              prop="status"
              show-overflow-tooltip
              align="center"
              label="状态"
              width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==='NOT_PASS'" type="danger">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
              <el-tag v-else-if="scope.row.status==='FINISH'||scope.row.status==='REVIEW_PASS'" type="success">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
              <el-tag v-else type="info">
                {{ eachDictName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                  :disabled="(scope.row.status==='REVIEW_PASS'||scope.row.status==='REVIEW')"
                  type="text" @click="onClickEdit(scope.row)">修改
              </el-button>
              <el-button
                  :disabled="!(scope.row.status==='REVIEW_PASS')"
                  type="text" @click="onClickPrint(scope.row)">打印
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @current-change="onChangeCurrent"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            background
            layout="total, prev, pager, next"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
    <product-info v-if="showInfo"/>
  </div>
</template>

<script>

import {getCodeTraceabilityList, getDictionaryItem, getModelMap} from "../../utils/interface";
import ProductInfo from "./ProductInfo";

export default {
  components: {
    ProductInfo,
  },
  data() {
    return {
      showInfo: false,
      modelOptions: [],
      tableData: [],
      modelMap: [],
      queryParams: {
        productModel: '',
        status: '',
        current: 1,
        pageSize: 5,
        total: 0,
        enterpriseUuid:this.$store.state.isUsermessage.uuid,
      },
      enumStatus: [{
        value: 'INIT',
        name: '未审核',
      }, {
        value: 'REVIEW',
        name: '待审核',
      }, {
        value: 'NOT_PASS',
        name: '审核不通过',
      }, {
        value: 'REVIEW_PASS',
        name: '审核通过',
      }, {
        value: 'FINISH',
        name: '已生成',
      },],
      listLoading: false,
    };
  },
  created() {

  },
  methods: {
    initData() {
      this.getPageList()
      this.getOptionsData()
      this.getModelMap()
    },
    getPageList() {
      this.listLoading = true
      getCodeTraceabilityList(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {
      getDictionaryItem({
        groupCode: 'FMZS-GGXH'
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.modelOptions = res
        }
      });
    },
    // 获取规格型号
    getModelMap(){
      getModelMap().then((res) => {
        this.modelMap = res;
      })
    },

    onClickEdit(row) {
      this.$emit('onChangeType', 0, row)
    },
    onClickPrint(row) {
      this.$emit('onChangeStep', 4, row)
    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.queryParams = {
        productModel: '',
        status: '',
        current: 1,
        pageSize: 5,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e) {
      this.queryParams.current = e
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
    eachModel(modelKey) {
      return this.modelMap.find(item => item.modelKey === modelKey).modelValue
    },
  },
};
</script>

<style scoped lang="less">
.applied-list {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceability/AppliedList.vue